import Vue from 'vue'
import VueI18n from 'vue-i18n'
import utils from '@/utils/utils';

function returnType(langNo){
  let type = 'zh_cn';

  switch (Number(langNo)) {
    case 1: type = 'zh_cn'; break;
    case 2: type = 'ja_jp'; break;
    case 3: type = 'zh_hk'; break;
    case 4: type = 'en_us'; break;
    case 5: type = 'ko_kr'; break;
    default: type = 'zh_cn';
  }

  return type;
}

Vue.use(VueI18n)

// 从URL获取语言类型和货币
utils.getLanTypeFromUrl();
const DEFAULT_LANG = returnType(window.localStorage.getItem('lan_type')) || 'zh_cn';
const LOCALE_KEY = 'lan_type'

const locales = {
  zh_cn: require('./zh_cn.js'),
  ja_jp: require('./ja_jp.js'),
  zh_hk: require('./zh_hk.js'),
  en_us: require('./en_us.js'),
  ko_kr: require('./ko_kr.js'),
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
})

export const setup = lang => {
  if (lang === undefined) {
    lang = returnType(window.localStorage.getItem(LOCALE_KEY))
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  // window.localStorage.setItem(LOCALE_KEY, lang)

  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  Vue.config.lang = lang
  i18n.locale = lang
}

setup()
export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js